import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";
import {NavigationButtonPosition, NavigationSectionType} from "../../../model2/navigation/@const";
import {PersonalViewLocation} from "../../../model2/view/personal-view/@types";
import {SpacePreferences} from "../../../model2/space/@types";

const fieldsConfig = {

    'spacesSorting': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : [],
    },
    'spacesPreferences': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : {},
    },


    'sortPositions': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : [],
    },
    'buttonPositions' : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : [],
    },
    'viewLocations' : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : {},
    },
    'portfolioLocations' : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : {},
    },
    'personalViews'     : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : {}
    },
    'menuSectionsCollapsed' : {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : []
    },
}

// !!! this is config for current company only

export default class UserSettings_Navigation extends ServerSettings {

    private configAllCompanies  : any   // object with config for all companies

    public sortPositions            : ID[]      // old way to sort buttons ... wee wont need it
    public buttonPositions          : { [key:string]: NavigationButtonPosition }       // id -> position dict
    public spacesSorting            : ID[]      // arrays of space ids used for sorting
    public spacesPreferences        : {[key: string]: SpacePreferences}      // dict spaceId - Preferences
    public viewLocations            : {[key: string]: NavigationSectionType} // dont use directly ! - what is that ?
    public portfolioLocations       : {[key: string]: NavigationSectionType} // dont use directly !
    public personalViews            : {[key: string]: PersonalViewLocation}     // ok these are pesonal views locations

    public menuSectionsCollapsed    : string[]  = []        // Contains IDs of collapsed menu groups

    constructor(configAllCompanies: any) {

        const config = _.get(configAllCompanies, gd.companyId, {})
        super(config, fieldsConfig);

        this.configAllCompanies = configAllCompanies

        this.sortPositions          = this.initValue('sortPositions')
        this.buttonPositions        = this.initValue('buttonPositions') || [] // wow I got null in some cases so this is a patch
        this.viewLocations          = this.initValue('viewLocations')
        this.portfolioLocations     = this.initValue('portfolioLocations')
        this.personalViews          = this.initValue('personalViews')
        this.spacesSorting          = this.initValue('spacesSorting')
        this.spacesPreferences      = this.initValue('spacesPreferences') || {}
        this.menuSectionsCollapsed  = this.initValue('menuSectionsCollapsed') || []


    }

    getViewLocation(viewId:string):NavigationSectionType|undefined {
        return this.viewLocations[viewId] ? this.viewLocations[viewId] : undefined
    }

    setViewLocation(viewId:string, location:NavigationSectionType) {
        this.viewLocations[viewId] = location
    }

    getPortfolioLocation(portfolioId:string):NavigationSectionType {
        return this.portfolioLocations[portfolioId] ? this.portfolioLocations[portfolioId] : NavigationSectionType.PROJECTS
    }

    setPortfolioLocation(portfolioId:string, location:NavigationSectionType) {
        this.portfolioLocations[portfolioId] = location
    }

    toJson() {
        const result = {}
        this.valueToJson(result, 'sortPositions')
        this.valueToJson(result, 'buttonPositions')
        this.valueToJson(result, 'viewLocations')
        this.valueToJson(result, 'portfolioLocations')
        this.valueToJson(result, 'personalViews')
        this.valueToJson(result, 'spacesSorting')
        this.valueToJson(result, 'spacesPreferences')
        this.valueToJson(result, 'menuSectionsCollapsed')

        this.configAllCompanies[gd.companyId] = result

        return this.configAllCompanies;
    }
}
